import { render, staticRenderFns } from "./ContingenciaMecanizadoTab.vue?vue&type=template&id=70827ce2&"
import script from "./ContingenciaMecanizadoTab.vue?vue&type=script&lang=js&"
export * from "./ContingenciaMecanizadoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports